export enum Languages {
  ua = 'ua',
  ru = 'ru',
  en = 'en'
}
